import { IconComponentProps } from '../IconTypes';

const GraphExpand = ({ className }: IconComponentProps) => (
  <svg className={className} fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.0042 17C14.2386 15.6967 14.9958 13.9368 14.9958 12C14.9958 10.0632 14.2386 8.30327 13.0042 7M9.00421 17C10.2386 15.6967 10.9958 13.9368 10.9958 12C10.9958 10.0632 10.2386 8.30327 9.00421 7"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="1.25"
    />
  </svg>
);

export default GraphExpand;
